import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// flowType: 'implicit', not the supabase-js v2 default 'pkce'. PKCE password
// recovery links only exchange successfully on the SAME browser/device that
// called resetPasswordForEmail (the code_verifier lives in that browser's
// local storage) -- but a reset is routinely requested on one device and
// opened from the email on another, which broke recovery outright. Implicit
// puts the token straight in the URL hash (#access_token=...&type=recovery),
// which works regardless of device. No OAuth/magic-link flow exists in this
// app (grep confirms), so this has no effect anywhere except recovery.
// detectSessionInUrl is explicit here (true, the default) since the recovery
// link being picked up automatically on page load depends on it.
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    flowType: 'implicit',
    detectSessionInUrl: true
  }
})
